import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import { buildFS, getNode } from './fs';
import { openApp, setWallpaper } from 'events/bus';

function Explorer() {
  const fs = useMemo(() => buildFS(), []);
  const [path, setPath] = useState(['Home']);
  const current = getNode(fs, path);
  const items = current?.children || [];
  const [selectedId, setSelectedId] = useState(null);
  const selected = items.find(i => i.id === selectedId);
  function openItem(item) {
    if (item.type === 'folder') {
      setPath([...path, item.name]);
      return;
    }
    // Default open with
    switch (item.kind) {
      case 'document':
        openApp('Documents');
        break;
      case 'picture':
        openApp('Pictures');
        break;
      case 'track':
        openApp('Winamp');
        break;
      case 'quote':
        openApp('Quotes');
        break;
      case 'domain':
        openApp('Domains');
        break;
      default:
    }
  }
  return (
    <Div>
      <aside className="sidebar">
        <Tree node={fs} path={path} setPath={setPath} />
      </aside>
      <main className="content">
        <div className="crumbs">
          {path.map((p, i) => (
            <span
              key={i}
              className="crumb"
              onClick={() => setPath(path.slice(0, i + 1))}
            >
              {p}
              {i < path.length - 1 ? ' \\ ' : ''}
            </span>
          ))}
        </div>
        <div className="actions">
          {selected?.kind === 'picture' && (
            <button
              className="btn"
              onClick={() => selected && setWallpaper(selected.src || '')}
            >
              Set as wallpaper
            </button>
          )}
        </div>
        <div className="grid">
          {items.map(item => (
            <div
              key={`${item.type}-${item.name}-${item.id || ''}`}
              className="tile"
              role="button"
              tabIndex={0}
              onClick={() => setSelectedId(item.id)}
              onDoubleClick={() => openItem(item)}
            >
              <div className={`icon ${item.kind}`} />
              <div className="name" title={item.name}>
                {item.name}
              </div>
            </div>
          ))}
        </div>
      </main>
    </Div>
  );
}

function Tree({ node, path, setPath, depth = 0 }) {
  return (
    <ul className="tree">
      <li>
        <button
          className={depth === 0 ? 'root' : ''}
          onClick={() => setPath(path.slice(0, depth + 1))}
        >
          {node.name}
        </button>
      </li>
      {node.children
        ?.filter(c => c.type === 'folder')
        .map(child => (
          <li key={child.name} className="child">
            <Tree
              node={child}
              path={[...path, child.name]}
              setPath={setPath}
              depth={depth + 1}
            />
          </li>
        ))}
    </ul>
  );
}

// fs helpers are imported from './fs' for testability

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: grid;
  grid-template-columns: 220px 1fr;
  overflow: hidden;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .sidebar {
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    background: #f8f8f8;
    overflow: auto;
    padding: 6px;
  }
  .tree {
    list-style: none;
    margin: 0;
    padding: 0 0 0 8px;
  }
  .tree .child {
    margin-left: 8px;
  }
  .tree button {
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    font-size: 12px;
    padding: 4px;
  }
  .tree button.root {
    font-weight: 700;
  }

  .content {
    overflow: auto;
    padding: 12px;
  }
  .actions {
    margin-bottom: 8px;
  }
  .btn {
    font-size: 12px;
    padding: 4px 8px;
  }
  .crumbs {
    font-size: 11px;
    margin-bottom: 8px;
    color: #2f71cd;
  }
  .crumb {
    cursor: pointer;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
  }
  .tile {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 8px;
    background: #fff;
  }
  .icon {
    width: 32px;
    height: 24px;
    margin-bottom: 6px;
    background: #cfe0ff;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .name {
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export default Explorer;
